import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import { setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import Anchor from '../../../../../components/link/Anchor';

/**
 *  추천 상품에 연결된 상품 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { getProductSubCategoryList } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} />,
      dataIndex: 'storeName',
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} />,
      dataIndex: 'storeId',
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'상품 번호'} />,
      dataIndex: 'id',
      render: (value) => <OpenProductDetail text={value} productId={value} />,
    },
    {
      title: <TableColumnTitle title={'1차 카테고리'} />,
      dataIndex: 'mainCategory',
    },
    {
      title: <TableColumnTitle title={'2차 카테고리'} />,
      dataIndex: 'isSubCategoryExists',
      render: (value, record) =>
        value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: record.id,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value) => PRODUCT_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'상품명'} />,
      dataIndex: 'productName',
      render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'판매가 (원)'} />,
      dataIndex: 'originPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인가 (원)'} />,
      dataIndex: 'discountPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인율 (%)'} />,
      dataIndex: 'discountRate',
    },
    {
      title: <TableColumnTitle title={'할인기간'} />,
      dataIndex: 'discountPeriod',
    },
    {
      title: <TableColumnTitle title={'실판매가 (원)'} />,
      dataIndex: 'salesPrice',
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'등록일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
